export enum OfferLabelsEnum {
  EMPTY = "EMPTY",
  TEST = "TEST",
  EXCLUSIVE = "EXCLUSIVE",
  NO_TRAFFIC = "NO TRAFFIC",
  RESALE = "RESALE",
  IS_NEW = "NEW",
}